import React from 'react';

export default function BlockerLinkButton({align, theme, link, icon, text}) {
  if(!link) {
    return null;
  }

  align = align || '';
  theme = theme || '';
  icon = icon || '';

  return (
    <a className={`${align} ${theme}`} href={link}>
      <span className={icon}>{text}</span>
    </a>
  )
};
